import React, { ReactNode } from 'react'
import { ButtonSizeValue } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { MasterClassWordmark } from './MasterClassWordmark'

interface EnhancedCtaCopyProps {
  children: ReactNode
  size?: ButtonSizeValue
}

export const EnhancedCtaCopy = ({
  children,
  size = 'md',
}: EnhancedCtaCopyProps) => {
  const { t } = useTranslation('@mc/growth')
  const defaultCtaCopy = t('cta.getMasterclass')

  if (typeof children === 'string' && children === defaultCtaCopy) {
    const parts = children.split('MasterClass')
    const iconHeight = ['xs', 'sm'].includes(size) ? 10 : 12

    return (
      <span>
        <span className='mc-sr-only'>{children}</span>
        <span aria-hidden='true'>
          {parts.map((part, index) => (
            <span key={index} className='d-inline-flex align-items-center'>
              {part}
              {index < parts.length - 1 && (
                <MasterClassWordmark height={iconHeight} className='mc-mx-1' />
              )}
            </span>
          ))}
        </span>
      </span>
    )
  }

  return children
}
